import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { OnboardingAddRolesPage } from "./Page";

interface OnboardingRolesContainerProps {
  nextStagePath: (isPermanentPlacement: boolean, isSurfaceShiftsEnabled: boolean) => string;
}

/**
 * @deprecated. We are working on deprecating this page. Once we have have new signing up flow, this page will be removed.
 *
 * New roles page: src/appV2/redesign/Onboarding/OnboardingFlowContainer/RolesStep/Container.tsx
 */
export function OnboardingRolesContainer(props: OnboardingRolesContainerProps) {
  const { nextStagePath } = props;

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <OnboardingAddRolesPage nextStagePath={nextStagePath} />
    </ThemeProvider>
  );
}
